<template>
  <header :class="{ top: flag }">
    <div class="titlebox">
      <router-link to="/" title="回到首页">
        <svg
          id="svg"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          class="logo"
          width="50"
          height="50"
          viewBox="0, 0, 400,400"
        >
          <g id="svgg">
            <path
              id="path0"
              d="M185.478 21.442 C 153.498 27.723,132.430 56.840,130.971 96.775 C 128.983 151.191,154.028 181.395,201.333 181.630 C 248.296 181.864,274.974 150.547,272.983 97.521 C 270.976 44.034,234.025 11.908,185.478 21.442 M221.594 35.036 C 243.285 45.151,251.128 62.511,251.243 100.667 C 251.388 148.666,236.130 170.794,202.667 171.116 C 170.256 171.428,153.011 147.466,152.924 102.000 C 152.818 47.317,183.587 17.313,221.594 35.036 M56.000 39.925 C 56.000 41.269,63.798 63.082,133.371 256.364 L 177.897 380.062 199.775 379.698 L 221.653 379.333 254.116 290.000 C 271.971 240.867,289.557 192.567,293.197 182.667 C 296.836 172.767,309.743 137.300,321.878 103.852 C 334.013 70.405,344.325 42.039,344.794 40.817 C 345.570 38.794,343.829 38.629,325.347 38.964 L 305.048 39.333 285.062 96.000 C 257.837 173.191,227.558 259.226,213.628 298.970 C 207.272 317.103,201.698 331.503,201.241 330.970 C 200.784 330.436,197.059 320.400,192.963 308.667 C 188.867 296.933,167.232 235.433,144.885 172.000 C 122.538 108.567,102.849 52.617,101.132 47.667 L 98.009 38.667 77.004 38.667 C 64.724 38.667,56.000 39.189,56.000 39.925 M187.153 48.119 C 163.330 55.023,149.999 87.068,158.066 118.040 C 168.672 158.757,225.999 162.905,243.702 124.237 C 262.835 82.444,228.444 36.152,187.153 48.119 M218.010 57.606 C 237.428 69.940,240.884 117.870,223.600 135.129 C 203.279 155.420,175.654 142.059,170.601 109.496 C 164.438 69.769,191.142 40.540,218.010 57.606 M190.000 66.759 C 188.533 67.339,185.683 67.855,183.667 67.906 C 179.198 68.020,178.644 71.622,183.000 72.241 C 185.981 72.664,186.002 72.830,186.362 99.016 L 186.723 125.365 183.362 126.896 C 177.520 129.558,179.668 130.667,190.667 130.667 C 201.917 130.667,203.949 129.572,197.333 127.075 C 193.607 125.668,193.333 125.098,193.333 118.748 L 193.333 111.932 197.267 113.966 C 211.812 121.487,225.375 110.499,225.203 91.333 C 225.018 70.822,211.626 59.506,198.266 68.573 L 193.492 71.812 193.079 68.759 C 192.746 66.295,192.152 65.909,190.000 66.759 M213.291 72.262 C 220.278 79.761,220.692 100.411,214.023 108.775 C 209.956 113.875,201.816 114.171,196.742 109.404 C 191.400 104.385,191.523 78.702,196.916 73.073 C 201.524 68.263,209.211 67.882,213.291 72.262 M178.667 186.511 C 178.667 187.159,179.867 188.003,181.333 188.386 C 183.913 189.061,184.000 190.205,184.000 223.333 C 184.000 256.462,183.913 257.606,181.333 258.280 C 175.514 259.802,179.192 261.333,188.667 261.333 C 197.922 261.333,202.563 259.406,195.667 258.426 C 192.758 258.013,192.655 257.485,192.293 241.000 L 191.920 224.000 195.182 224.000 C 198.121 224.000,212.000 253.792,212.000 260.100 C 212.000 260.778,215.000 261.333,218.667 261.333 C 225.635 261.333,227.665 259.303,222.095 257.905 C 220.207 257.431,218.051 255.335,216.926 252.879 C 213.963 246.410,206.214 223.985,206.807 223.598 C 207.097 223.409,209.587 222.230,212.342 220.978 C 228.162 213.788,224.790 191.676,207.126 186.772 C 200.946 185.055,178.667 184.852,178.667 186.511 M207.880 191.271 C 222.441 198.801,213.971 221.333,196.580 221.333 L 192.000 221.333 192.000 205.556 C 192.000 186.481,194.415 184.308,207.880 191.271 "
              stroke="none"
              fill="#000000"
              fill-rule="evenodd"
            ></path>
          </g>
        </svg>
        <h1>OOPVR</h1>
      </router-link>
    </div>

    <nav>
      <ul class="main">
        <li
          v-for="(items, index) in treeData"
          :key="index"
          v-show="items.meta.disabled"
        >
          <!--遍历一级栏目-->
          <router-link :to="items.path">{{ items.meta.title }}</router-link>
          <!-- <span v-if="items.children" ref="ss" class="triangle"></span> -->
          <!-- 如果有二级栏目则生成 -->
          <!-- <ul v-if="items.children" class="drop more">
            <li v-for="(item, index) in items.children" :key="index"> -->
          <!--遍历二级栏目-->
          <!-- <router-link :to="item.path">{{ item.meta.title }}</router-link>
            </li>
          </ul> -->
        </li>
      </ul>
    </nav>
    <ul class="netusermessage">
      <li>
        <div class="userbox">
          <a-button type="primary" @click="showModal" v-if="!userState">
            登录
          </a-button>
          <a-modal
            title="登录/注册"
            :visible="visible"
            :maskClosable="false"
            @cancel="handleCancel"
            :footer="null"
          >
            <a-form :form="form" @submit="handleSubmit">
              <a-form-item
                v-if="this.showinput"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
                <a-input
                  v-decorator="[
                    'userIphone',
                    {
                      rules: [
                        { required: true, message: '请输入正确的手机号码' },
                      ],
                    },
                  ]"
                  placeholder="请输入手机号码"
                />
              </a-form-item>

              <a-form-item
                v-if="this.showinput"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
                <a-input-search
                  v-decorator="[
                    'verification',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请输入正确的验证码',
                        },
                      ],
                    },
                  ]"
                  placeholder="请输入验证码"
                >
                  <a-button
                    type="primary"
                    :loading="buttonloading"
                    slot="enterButton"
                    @mouseenter="enterLoading"
                    :disabled="disabledButton"
                  >
                    {{ buttonText }}
                  </a-button>
                </a-input-search>
              </a-form-item>

              <a-form-item
                v-if="!this.showinput"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
                <a-input
                  v-decorator="[
                    'userAccount',
                    {
                      rules: [
                        { required: true, message: '请输入账号 / 手机号码' },
                      ],
                    },
                  ]"
                  placeholder="账号 / 手机号码"
                  autocomplete
                >
                  <a-icon
                    slot="prefix"
                    type="user"
                    style="color: rgba(0, 0, 0, 0.25)"
                /></a-input>
              </a-form-item>

              <a-form-item
                v-if="!this.showinput"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
                <a-input-password
                  v-decorator="[
                    'userPassword',
                    {
                      rules: [{ required: true, message: '请输入密码' }],
                    },
                  ]"
                  placeholder="密码"
                  autocomplete
                  ><a-icon
                    slot="prefix"
                    type="lock"
                    style="color: rgba(0, 0, 0, 0.25)"
                /></a-input-password>
              </a-form-item>

              <h3 class="other" v-if="this.showinput" @click="showinputfun()">
                其他登录方式
              </h3>
              <h3 class="other" v-if="!this.showinput" @click="showinputfun()">
                短信验证登录
              </h3>
              <a-button
                key="submit"
                type="primary"
                :loading="loading"
                html-type="submit"
              >
                登录
              </a-button>
              <h3 class="narration">
                注册登录即表示同意
                <span>
                  <router-link to="/Exemptionconfig" target="_blank"
                    >免责声明</router-link
                  ></span
                ><span
                  >、<router-link to="/Privacyconfig" target="_blank"
                    >隐私政策</router-link
                  >
                </span>
              </h3>
            </a-form>
          </a-modal>

          <div v-if="userState">
            <a-popover v-model="visiblemenu" placement="bottom" trigger="click">
              <template slot="title">
                <span>{{ this.$store.state.netuser.name }}</span>
              </template>
              <template slot="content">
                <p><router-link to="/yyds">个人主页 </router-link></p>
                <p><router-link to="/User/index">控制台 </router-link></p>
                <p><router-link to="/User/release/telegraphs">内容管理</router-link></p>
                <a-popconfirm
                  placement="bottom"
                  ok-text="是"
                  cancel-text="否"
                  @confirm="confirm"
                >
                  <template slot="title">
                    <p>确认{{ this.$store.state.netuser.name }}退出登录？</p>
                  </template>
                  <a-button>退出登录</a-button>
                </a-popconfirm>
              </template>
              <a-avatar :src="this.$store.state.netuser.imageurl" />
            </a-popover>
          </div>
        </div>
        <!-- 
          <div class="section">
            <h6>切换</h6>
            <h6>退出</h6>
            <span class="triangle"></span>
          </div> -->
      </li>
    </ul>

    <div @click="show()" class="menubar">
      <!--汉堡条-->
      <div class="hamburger tomotion">
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
      </div>
    </div>

    <!-- <div>
      <a-button type="primary" @click="showModal">
        Open Modal with async logic
      </a-button>
    </div> -->
  </header>
</template>

<script>
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 28 },
};
const formTailLayout = {
  labelCol: { span: 2 },
  wrapperCol: { span: 18, offset: 4 },
};

export default {
  name: "Header",
  data() {
    return {
      flag: false,
      scroll: 0, //当前滚动值
      new_scrolls: 0, //之前滚动值
      netUserImage: "",
      userState: this.$store.state.index.netUserState,
      treeData: this.$store.state.boxMessage.routerData,

      //登录框
      visible: this.$store.state.boxMessage.loginbox,
      loading: false,

      visiblemenu:false,

      //socket
      socket: null,

      //表单
      formItemLayout,
      formTailLayout,
      buttonText: "获取验证码",
      buttonloading: false,
      disabledButton: false,
      showinput: true,
      form: this.$form.createForm(this, { name: "dynamic_rule" }),
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollYlo);
    this.WebSocketTool();
  },
  methods: {
    scrollYlo: function () {
      this.scroll = window.scrollY; //获取当前滚动数值
      if (this.new_scrolls < this.scroll && this.scroll > 50) {
        this.flag = true; //判断上一次滚动的数值是否小于当前滚动数值并且大于50px(header);表示用户向下滚
        this.visiblemenu=false;
      } else if (this.new_scrolls > this.scroll) {
        this.flag = false; //如上一个条件不满足则再进行判断上一次滚动的数值必定大于当前滚动，表示用户向上滚
      }
      this.new_scrolls = this.scroll;
    },
    show: function () {
      this.treeData.reverse(); //倒序
      let menushow = document.getElementsByClassName("hamburger")[0];
      let namenav = document.getElementsByTagName("nav")[0];
      let clsname = "islink";
      let navsname = "navs";
      if (menushow.classList.contains(clsname)) {
        menushow.classList.remove(clsname);
        namenav.classList.remove(navsname);
      } else {
        menushow.classList.add(clsname);
        namenav.classList.add(navsname);
      }
    },

    //对话框
    showModal() {
      this.visible = true;
    },
    showinputfun() {
      this.showinput = !this.showinput;
    },
    handleCancel(e) {
      this.visible = false;
      this.$store.commit("setLoginbox", false);
    },

    //表单
    // check() {
    //   this.form.validateFields((err) => {
    //     if (!err) {
    //       console.info("success");
    //     }
    //   });
    // },
    handleChange(e) {
      // this.checkNick = e.target.checked;
      this.$nextTick(() => {
        this.form.validateFields(["verification"], { force: true });
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.loading = true;
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // console.log(values);
          if (values.userIphone) {
            values.userIphone = this.$Encrypt(values.userIphone);
          }
          if (values.userAccount) {
            values.userAccount = this.$Encrypt(values.userAccount);
          }
          if (values.userPassword) {
            values.userPassword = this.$Encrypt(values.userPassword);
          }
          console.log(this.$store.state.index.orTempKey);
          values.orTempKey = this.$store.state.index.orTempKey;

          values.equipment = this.$store.state.index.equipment;
          values.equipmentEdition = this.$store.state.index.equipmentEdition;
          let $this = this;
          this.$post("/net/client/user/login", values)
            .then((response) => {
              if (response.code != 1) {
                this.$message.error(response.msg, 5);
                $this.loading = false;
                return;
              }

              response.data.iphone = this.$Decrypt(response.data.iphone);  
              this.$store.commit("setStateUser", response.data);
              this.$store.commit("setToken", response.data.token);
              this.$store.commit(
                "setWebSocketSecretKey",
                response.data.webSocketSecretKey
              );
              this.$store.commit("setNetUserState", true);
              // console.log(this.$store.state.netuser);
              // localStorage.setItem("netuser",JSON.stringify(response.data))
              this.$message.success(response.data.name, 5);
              $this.WebSocketTool();
              $this.loading = false;
              $this.visible = false;
              $this.userState = this.$store.state.netuser;
            })
            .catch((error) => {
              this.$message.error(error.msg, 5);
              $this.loading = false;
            });
        } else {
          this.loading = false;
        }
      });
    },

    /**
     * 确认退出登录
     */
    confirm() {
      this.$post("/net/client/user/loginout", {
        webSocketSecretKey: this.$store.state.index.webSocketSecretKey,
        token: this.$store.state.index.token,
      })
        .then((response) => {
          if (response.code != 1) {
            this.$message.error(response.msg, 5);
            return;
          }
          this.$message.success(
            "退出" + this.$store.state.netuser.name + "完成！",
            5
          );
          this.$store.commit("setStateUser", null);
          localStorage.removeItem("vuex-netUser");
          this.$store.commit("setToken", null);
          this.$store.commit("setWebSocketSecretKey", null);
          this.$store.commit("setNetUserState", false);

          this.$router.replace({
            path: "/",
          });
        })
        .catch((error) => {
          this.$message.error(error.msg, 5);
        });
    },

    /**
     * 获取验证码
     */
    enterLoading() {
      this.buttonloading = true;
      this.form.validateFieldsAndScroll((err, values) => {
        if (values.userIphone) {
          values.userIphone = this.$Encrypt(values.userIphone);
          values.orTempKey = this.$store.state.index.orTempKey;
          this.$post("/net/netuser/cloudcode", values)
            .then((response) => {
              if (response.code != 1) {
                this.$message.error(response.msg, 5);
                this.buttonloading = false;
                return;
              }

              this.buttonloading = false;
            })
            .catch(function (error) {
              console.log(error);
              this.buttonloading = false;
            });
        } else {
          this.buttonloading = false;
        }
      });
    },

    WebSocketTool() {
      // let socket = this.socket;
      if (this.$store.state.index.token) {
        if (typeof WebSocket == "undefined") {
          return;
          // console.log("您的浏览器不支持WebSocket");
        } else {
          // console.log("您的浏览器支持WebSocket");

          //实现化WebSocket对象，指定要连接的服务器地址与端口  建立连接
          //等同于socket = new WebSocket("ws://localhost:8888/xxxx/im/25");
          //var socketUrl="${request.contextPath}/im/"+$("#userId").val();
          var socketUrl =
            this.$host +
            "/net/netuser/" +
            this.$store.state.index.webSocketSecretKey;
          socketUrl = socketUrl.replace("https", "ws").replace("http", "ws");
          // console.log(socketUrl);
          // console.log(this.socket+"-------------------")
          if (this.socket != null) {
            this.socket.close();
            this.socket = null;
          }
          this.socket = new WebSocket(socketUrl);
          //打开事件
          // this.socket = new WebSocket(socketUrl);
          //打开事件
          this.socket.onopen = function () {
            // console.log("websocket已打开");
            // socket.send('{"toUserId":"' + 1 + '","contentText":"' + 3 + '"}');
          };

          //获得消息事件
          this.socket.onmessage = function (msg) {
            // console.log(msg.data);
            //发现消息进入    开始处理前端触发逻辑
          };
          //关闭事件
          this.socket.onclose = function () {
            // this.close();
            // console.log("websocket已关闭");
          };
          //发生了错误事件
          this.socket.onerror = function () {
            // console.log("websocket发生了错误");
          };
        }
      }
    },
  },
  watch: {
    "$store.state.boxMessage.routerData": function (newFlag, oldFlag) {
      this.treeData = newFlag;
    },
    visible: function (newFlag, oldFlag) {
      this.visible = newFlag;
    },
    "$store.state.index.netUserState": function (newFlag, oldFlag) {
      this.userState = newFlag;
    },
  },
};
</script>


<style lang="less" scope>
.top {
  transform: translateY(-50px);
  -ms-transform: translateY(-50px);
  -webkit-transform: translateY(-50px);
  -moz-transform: translateY(-50px);
  -o-transform: translateY(-50px);
}
header {
  //头
  position: fixed;
  display: flex;
  flex-direction: row;
  height: 50px;
  width: 100%;
  line-height: 50px;
  background-color: #7977771f;
  border-bottom: none;
  transition: all 0.5s ease;
  z-index: 100;

  .titlebox {
    width: 35%;
    height: 100%;
    border-radius: 0% 5% 5% 0%;
    text-align: center;
    background: linear-gradient(
      to right,
      rgb(255, 254, 254),
      rgba(71, 60, 60, 0.021)
    );

    color: transparent;
    .logo {
      // // width: 50px;
      // fill: white;
      // padding-right: 15px;
      padding-bottom: 5px;
      display: inline-block;
      vertical-align: middle;
    }
    h1 {
      font-weight:300;
      letter-spacing: 2px;
      font-size: 18px;
      display: inline-block;
    }
    a {
      background-color: unset !important;
    }
  }
  nav {
    width: 60%;
    // height: 100%;
    border-radius: 4px;
    border-bottom: none;
    text-align: center;
    .main {
      display: flex;
      flex-direction: row-reverse;
    }
    .main > li {
      width: 12%;
      margin: 0 2%;
    }
    a {
      display: block;
      height: 50px;
      width: 80%;
      font-family: monospace;
      font-family: "Raleway", sans-serif;
      text-decoration: none;
      text-transform: capitalize;
      font-size: 15px;
      color: rgba(12, 12, 12, 0.808);
      font-weight: normal;
      transition: background-color 0.5s ease-in-out;
    }

    .triangle {
      //三角形
      float: right;
      width: 15px;
      height: 15px;
      margin-top: -31px;
      margin-right: 5px;
      border-top: 7px solid transparent;
      border-right: 14px solid #fff;
      border-bottom: 7px solid transparent;
      transition: all 0.5s ease;
    }
    .main li a {
      font-weight: bold;
    }
    .drop {
      display: none;
      li {
        opacity: 0;
        transform-origin: top center;
        a {
          font-weight: normal;
          background-color: rgba(23, 23, 50, 0.7);
          color: rgba(241, 241, 241, 0.931);
        }
      }
    }

    .drop li a:hover {
      background-color: #7977771f;
    }
    .main li:hover .drop {
      display: block;
    }

    .main li:hover .triangle {
      transform: rotate(-90deg);
    }
    .main li:hover .more li:first-of-type {
      animation: more 0.3s ease-in-out forwards;
      animation-delay: 0s;
    }

    .main li:hover .more li:nth-of-type(2) {
      animation: more 0.3s ease-in-out forwards;
      animation-delay: 0.01s;
    }

    .main li:hover .more li:nth-of-type(3) {
      animation: more 0.3s ease-in-out forwards;
      animation-delay: 0.05s;
    }

    .main li:hover .more li:last-of-type {
      animation: more 0.3s ease-in-out forwards;
      animation-delay: 0.15s;
    }

    @keyframes more {
      //二级栏目动画
      from {
        opacity: 0;
        transform: translateX(30px) rotateY(90deg);
      }
      to {
        opacity: 1;
        transform: translateX(0) rotateY(0);
      }
    }
  }

  .netusermessage {
    width: 15%;
    margin-left: 10%;
    li .userbox {
      margin-right: 10px;

      .namespan {
        color: rgba(7, 7, 7, 0.781);
        font-size: 15px;
        font-weight: bold;
        cursor: pointer;
        padding: 5px;
      }
    }

    // li figure:hover .section {
    //   // display: block;
    //   // position: absolute;
    // }
    h6:hover {
      border-bottom: 2px solid #373a3f;
    }
  }

  .menubar {
    //菜单按钮
    position: fixed;
    display: none;
    left: 3px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    color: #ecf0f1;
    text-align: center;
    cursor: pointer;

    .hamburger .line {
      width: 50px;
      height: 5px;
      background-color: #98e5f8;
      display: block;
      margin: 8px auto;
      -webkit-transition: all 0.3s ease-in-out;
      -o-transition: all 0.3s ease-in-out;
      transition: all 0.3s ease-in-out;
    }
    .tomotion.islink {
      -webkit-transition: all 0.3s ease-in-out;
      -o-transition: all 0.3s ease-in-out;
      transition: all 0.3s ease-in-out;
      -webkit-transition-delay: 0.6s;
      -o-transition-delay: 0.6s;
      transition-delay: 0.6s;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      -o-transform: rotate(45deg);
      transform: rotate(45deg);
    }

    .tomotion.islink .line:nth-child(2) {
      width: 0px;
    }

    .tomotion.islink .line:nth-child(1),
    .tomotion.islink .line:nth-child(3) {
      -webkit-transition-delay: 0.3s;
      -o-transition-delay: 0.3s;
      transition-delay: 0.3s;
    }

    .tomotion.islink .line:nth-child(1) {
      -webkit-transform: translateY(13px);
      -ms-transform: translateY(13px);
      -o-transform: translateY(13px);
      transform: translateY(13px);
    }

    .tomotion.islink .line:nth-child(3) {
      -webkit-transform: translateY(-13px) rotate(90deg);
      -ms-transform: translateY(-13px) rotate(90deg);
      -o-transform: translateY(-13px) rotate(90deg);
      transform: translateY(-13px) rotate(90deg);
    }
  }
  .router-link-exact-active {
    background-color: rgba(82, 143, 235, 0.486);
  }
}

.other {
  margin-top: 1px;
  float: right;
  color: rgb(45, 122, 238);
  cursor: pointer;
}
.narration {
  margin-top: 10px;
  a {
    color: rgb(45, 122, 238);
  }
}
</style>


// WEBPACK FOOTER //
// src/index/Header.vue